import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import OrderGrinKitInfo from './OrderGrinKitInfo'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { getScopeProductsContent } from './scopeProducts'
import {
  GRIN_SCOPE_TYPE_LG,
  GRIN_SCOPE_TYPE_LG_MINI,
  GRIN_SCOPE_TYPE_MINI,
  GRIN_SCOPE_TYPE_REGULAR
} from 'consts/billingConsts'

const useStyles = makeStyles({
  body: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%'
  }
})

const OrderGrinKitsComparison = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { scopeLGOrdering } = useFeatureFlags()
  const scopeProducts = getScopeProductsContent(t)
  const scopes = [
    GRIN_SCOPE_TYPE_REGULAR,
    GRIN_SCOPE_TYPE_MINI,
    ...(scopeLGOrdering ? [GRIN_SCOPE_TYPE_LG, GRIN_SCOPE_TYPE_LG_MINI] : [])
  ].map(scopeType => {
    const scope = scopeProducts[scopeType]

    return {
      title: scope.name,
      subTitle: scope.comparisonSubTitle,
      subTitleFontSize: scope.comparisonSubTitleFontSize,
      scopeImage: scope.comparisonImage,
      arrowImage: scope.comparisonArrowImage,
      width: scope.comparisonWidth,
      description: scope.comparisonDescription,
      descriptionFontSize: scope.comparisonDescriptionFontSize
    }
  })

  return (
    <div className={classes.body}>
      {scopes.map(item => (
        <OrderGrinKitInfo key={item.title} {...item} />
      ))}
    </div>
  )
}

export default OrderGrinKitsComparison
